<storever-loading-data *ngIf="isLoading else dataForm"></storever-loading-data>
<ng-template #dataForm>
  <form  class="formHeight">
    <ul class="list-group">
      <div class="width-33" style="padding-bottom: 40px">
        <storever-element-group
          [icon]="'fal fa-exclamation'"
          [title]="'SHIPPINGS_EDIT_TITLE_MAIN'"
          [config]="dataConfig.groupConfigs.groupConfigs[0].config"
          [form]="dataConfig.form.get(['general'])"
          [isAdd]="isAdd"
          [isEdit]="isEdit"
          [paramEdit]="{
          text:dataConfig.form.get(['billing' , 'sapCode']).value ? null: 'GENERIC_EDIT',
          icon: dataConfig.form.get(['billing' , 'sapCode']).value ? null:'fal fa-edit', type: 'order', case: 'general'
          }"
          (save)="save('general')"
          (undo)="undo(['general'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-33 marginDisplay">
        <storever-element-group
          [icon]="'fad fa-money-check-edit'"
          [title]="'SHIPPINGS_EDIT_TITLE_BILLING'"
          [config]="dataConfig.groupConfigs.groupConfigs[1].config"
          [form]="dataConfig.form.get(['billing'])"
          [isAdd]="isAdd"
          [isEdit]="isEdit"
          [paramEdit]="{
          text: 'GENERIC_EDIT',
          icon: 'fal fa-edit', type: 'order', case: 'billing'
          }"
          (save)="save('billing')"
          (undo)="undo(['billing'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-33" *ngIf="!isAdd" >
        <storever-element-group
          [icon]="'fa-info-circle'"
          [title]="'ORDER_FORM_TITLE_OTHERS'"
          [config]="dataConfig.groupConfigs.groupConfigs[2].config"
          [form]="dataConfig.form.get(['misc', 'byForm'])"
          [isAdd]="isAdd"
          [isEdit]="isEdit"
          [paramEdit]="{text: 'none', icon: 'none', type: 'order', case: 'none'}"
          [stylingClass]="'dynamic-form'" >
        </storever-element-group></div>
      <div class="width-33" *ngIf="isAdd" >
      </div>
      <div class="width-33">
        <storever-element-group
          [icon]="'fa-address-book'"
          [title]="'ORDER_FORM_TITLE_ADDRESS_SIMPLE'"
          [config]="dataConfig.groupConfigs.groupConfigs[3].config"
          [form]="dataConfig.form.get(['address'])"
          [isAdd]="isAdd"
          [isEdit]="isEdit"
          [paramEdit]="{
          text:dataConfig.form.get(['billing' , 'sapCode']).value ? null: 'GENERIC_EDIT',
          icon: dataConfig.form.get(['billing' , 'sapCode']).value ? null:'fal fa-edit', type: 'order', case: 'billing'
          }"
          (save)="save('address')"
          (undo)="undo(['address'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-33">
        <storever-element-group
          [icon]="'fa-id-card'"
          [title]="'ORDER_FORM_TITLE_CONTACT'"
          [config]="dataConfig.groupConfigs.groupConfigs[4].config"
          [form]="dataConfig.form.get(['contact'])"
          [isAdd]="isAdd"
          [isEdit]="isEdit"
          [paramEdit]="{
          text:dataConfig.form.get(['billing' , 'sapCode']).value ? null: 'GENERIC_EDIT',
          icon: dataConfig.form.get(['billing' , 'sapCode']).value ? null:'fal fa-edit', type: 'order', case: 'billing'
          }"
          (save)="save('contact')"
          (undo)="undo(['contact'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-25"></div>
    </ul>
  </form>


<storever-footer-form
  class="submitBtn"
  [disabledSaveBtn]="true"
  [extraInfo]="error"
  [simpleFooter]="true"
  [isDelete]="dataConfig.form.get(['billing' , 'sapCode']).value ? false : true"
  [form]="dataConfig.form"
  [isEdit]="isEdit"
  [isSiteShippingEdit]="false"
  (saveOutput)="saveGlobal($event, dataConfig.form)"
  (resetOutput)="resetForm(dataConfig.form)"
  (cancelOutput)="cancel()"
></storever-footer-form>
</ng-template>

<!-- DEBUG -->
<div *ngIf="false" style="display:flex;">
<!--  <pre style="flex: 1 1 0px"> {{dataConfig.groupConfigs.groupConfigs | json}}</pre>-->
  <pre style="flex: 1 1 0px">dataConfig form: {{getInvalidControls(dataConfig.form)}}</pre>
</div>
